import {
  TOGGLE_DYNAMIC_MESSAGE_FILTER,
  TOGGLE_ALWAYS_OPEN_NEW_MESSAGES,
  TOGGLE_PRESS_ENTER_TO_SEND_MESSAGE,
  TOGGLE_RECEIVE_EMAIL_NOTIFICATIONS,
  SET_CONFIGURATION_ID,
} from "../constants/actionTypes";

const initialState = {
  id: null,
  dynamicMessageFilter: false,
  alwaysOpenNewMessages: false,
  pressEnterToSendMessage: false,
  receiveEmailNotifications: false,
};

function generalSettings(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_DYNAMIC_MESSAGE_FILTER:
      return {
        ...state,
        dynamicMessageFilter: !state.dynamicMessageFilter,
      };
    case TOGGLE_ALWAYS_OPEN_NEW_MESSAGES:
      return {
        ...state,
        alwaysOpenNewMessages: !state.alwaysOpenNewMessages,
      };
    case TOGGLE_PRESS_ENTER_TO_SEND_MESSAGE:
      return {
        ...state,
        pressEnterToSendMessage: !state.pressEnterToSendMessage,
      };
    case TOGGLE_RECEIVE_EMAIL_NOTIFICATIONS:
      return {
        ...state,
        receiveEmailNotifications: !state.receiveEmailNotifications,
      };
    case SET_CONFIGURATION_ID:
      return {
        ...state,
        id: action.id,
      };
    default:
      return state;
  }
}

export default generalSettings;
